import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import * as actions from "../../state/actions/keymans"
import { withStyles } from "@material-ui/core/styles"
import KeymanProfile from "./keyman-profile"
import CorporationProfile from "./corporation-profile"
import RankingProfile from "./ranking-profile"
import FaqProfile from "./faq-profile"
import FaqSeo from "./faq-seo"
import PersonSeo from "./person-seo"
import OrganizationSeo from "./organization-seo"
import { resolveHonorificKey, formatDepartment } from "../../utils/str"
import { DEPARTMENTS } from "../../constants/constants"

const mapStateToProps = (state, ownProps) => {
  return {
    honorificRelevantKeyman: state.search.honorificRelevantKeyman,
    departmentRelevantKeyman: state.search.departmentRelevantKeyman,
    relevantKeymans: state.search.relevantKeymans.toIndexedSeq().toArray(),
    isLoadingRelevantKeymans: state.search.isLoadingRelevantKeymans,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getKeymansRelevant: (data) =>
      dispatch(actions.getKeymansRelevant(data)),
  }
}

const styles = theme => ({
  section: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px #254E781A",
    position: "relative",
  },

  loaderContainer: {
    minHeight: "400px",
    position: "relative",
  },

  gutters: {
    width: "100%",
    background: "#040E35",
    color: "#FFFFFF",
    fontSize: "13px",
    fontWeight: "bold",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "8px 8px 0px 0px",
    padding: "10px 12px",
    boxSizing: "border-box",
    height: "37px",
  },
})

class KeymanDetail extends React.Component {
  componentDidMount() {
    const { item } = this.props
    if (item) {
      // 役職文字列から該当する役職keyをもとめる
      const honorificKey = resolveHonorificKey(item.honorific)
      // 役職文字列から該当する部門keyをもとめる
      const developmentName = formatDepartment(item.honorific)
      const development = DEPARTMENTS.find(item => item.name === developmentName)
      // 近しい決裁者を取得する
      this.props.getKeymansRelevant(
        {
          exclude_keyman_id: [item.id],
          honorific: [honorificKey],
          department: [development.value],
          corporation_id: [item.corporation_id],
        },
        true
      )
    }
  }

  render() {
    const {
      classes, item, departmentRankStats, getRankDepartmentsById, jsicSRankStats, getRankJsicSById, executiveCorporationTotal, executiveTotal, isLoadingRelevantKeymans
    } = this.props
    return (
      <div>
        <PersonSeo
          item={item}
        />
        <OrganizationSeo
          item={item}
          companyName={item.company_name}
          corporationId={item.corporation_id}
        />
        {(item.annual_income ||
          this.props.honorificRelevantKeyman ||
          this.props.departmentRelevantKeyman ||
          Object.keys(this.props.relevantKeymans).length !== 0) && (
          <FaqSeo
            item={item}
            honorificRelevantKeyman={this.props.honorificRelevantKeyman}
            departmentRelevantKeyman={this.props.departmentRelevantKeyman}
            relevantKeymans={this.props.relevantKeymans}
          />
        )}
        <div className={classes.section}>
          <KeymanProfile
            item={item}
            departmentRankStats={departmentRankStats}
            getRankDepartmentsById={getRankDepartmentsById}
            executiveCorporationTotal={executiveCorporationTotal}
            executiveTotal={executiveTotal}
          />
        </div>

        <div className={classes.section} style={{ marginTop: "40px" }}>
          <CorporationProfile
            item={item}
            jsicSRankStats={jsicSRankStats}
            getRankJsicSById={getRankJsicSById}
            corporationId={item.corporation_id}
            corporationName={item.company_name}
            source_url={item.corporation_source_url}
          />
        </div>

        <div className={classes.section} style={{ marginTop: "40px" }}>
          <RankingProfile
            item={item}
            departmentRankStats={departmentRankStats}
            getRankDepartmentsById={getRankDepartmentsById}
            jsicSRankStats={jsicSRankStats}
            getRankJsicSById={getRankJsicSById}
          />
        </div>
        {isLoadingRelevantKeymans && (
          <div className={classes.section} style={{ marginTop: "40px" }}></div>
        )}
        {(()=>{
          // 表示できる項目がある場合、決裁者を取得中の場合は表示する
          if ((item.annual_income ||
            this.props.honorificRelevantKeyman ||
            this.props.departmentRelevantKeyman ||
            Object.keys(this.props.relevantKeymans).length !== 0) ||
            !!isLoadingRelevantKeymans
          ) {
            return (
              <div className={classes.section} style={{ marginTop: "40px" }}>
                <FaqProfile
                  item={item}
                  honorificRelevantKeyman={this.props.honorificRelevantKeyman}
                  departmentRelevantKeyman={this.props.departmentRelevantKeyman}
                  relevantKeymans={this.props.relevantKeymans}
                  isLoadingRelevantKeymans={this.props.isLoadingRelevantKeymans}
                />
              </div>
            )
          }
        })()}
      </div>
    )
  }
}
KeymanDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(KeymanDetail)
)
